import { connect } from 'react-redux';

import SalesforceSandboxView from './SalesforceSandboxView.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount,changePrimaryConfiguration, fetchSalesforceIntegration, fetchTotalSalesforceIntegrations } from 'src/legacy/redux/actions/integrations/salesforceSandbox.jsx';  
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import _ from "lodash";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'salesforce_sandbox');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    user: state.users.me,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    totalSalesforceIntegrations: _.get(state, "legacyRootReducer.settings.integrations.salesforceSandbox.totalSalesforceIntegrations", 0),
    adminConfiguration: _.get(state,"legacyRootReducer.settings.integrations.salesforceSandbox.primaryIntegration",{}),
    primaryInstanceOverride: _.get(state, "legacyRootReducer.settings.integrations.salesforceSandbox.primaryInstanceOverride"),
  }
  }

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },
    
    fetchSalesforceIntegration: () =>{
      return dispatch(fetchSalesforceIntegration())
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    } ,
    
    fetchTotalSalesforceIntegrations: () => {
      return dispatch(fetchTotalSalesforceIntegrations())
    },
    changePrimaryConfiguration: (id, code) => {
      return dispatch(changePrimaryConfiguration(id, code));
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const SalesforceSandboxPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SalesforceSandboxView);

export default withUseHooks(SalesforceSandboxPage);
